var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropArrowIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 8,
    viewBox: "0 0 13 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.69279 7.60819C6.09153 8.06817 6.80528 8.06817 7.20402 7.60819L11.8825 2.21117C12.4438 1.56363 11.9839 0.556156 11.1269 0.556156H1.76992C0.912943 0.556156 0.452972 1.56363 1.01431 2.21117L5.69279 7.60819Z",
    fill: "#232D38"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropArrowIc);
export default __webpack_public_path__ + "static/media/drop_arrow_ic.127465ad14ccbc8c27796fce0bea9e60.svg";
export { ForwardRef as ReactComponent };